import { useEffect, useState } from "react";
/**
 * Custom hook to watch for changes in the user's timezone and reload the page if it changes. It is necessary for keeping all of the date inputs in current values
 *
 * @returns An object containing the current timezone.
 */
export const useTimezoneWatcher = () => {
  const [timezone, setTimezone] = useState(
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
      const currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (currentTimezone !== timezone) {
        window.location.reload(); // Reload on timezone change
      }
    }, 1000); // Check every 5 seconds

    return () => clearInterval(interval);
  }, [timezone]);
};
